module.exports = __webpack_public_path__ + "img/5.e5c53ffa.jpg";